var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as Headless from '@headlessui/react';
import { ChevronRightIcon } from '@heroicons/react/16/solid';
import clsx from 'clsx';
import React from 'react';
import { Link } from './link';
import { TouchTarget } from './button';
export function BreadcrumbList(_a) {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    return (_jsx("ol", Object.assign({}, props, { role: "list", className: clsx(className, 'flex items-center space-x-0.5'), children: children })));
}
export const BreadcrumbItem = React.forwardRef(function BreadcrumbItem(_a, ref) {
    var { className, children } = _a, props = __rest(_a, ["className", "children"]);
    let classes = clsx(
    // Base
    'flex items-center gap-0.5 rounded-lg px-2 py-2.5 text-base/6 sm:text-sm/5 font-medium text-zinc-500 dark:text-zinc-400', 
    // Hover
    'data-[hover]:bg-zinc-950/5 data-[slot=icon]:*:data-[hover]:fill-zinc-950');
    return 'href' in props ? (_jsx(Headless.CloseButton, { as: "li", ref: ref, children: _jsx(Link, Object.assign({ className: classes }, props, { children: _jsx(TouchTarget, { children: children }) })) })) : (_jsx(Headless.Button, Object.assign({}, props, { className: clsx('cursor-default', classes), ref: ref, children: _jsx(TouchTarget, { children: children }) })));
});
export function BreadcrumbLabel(_a) {
    var { className } = _a, props = __rest(_a, ["className"]);
    return _jsx("span", Object.assign({ className: clsx(className, 'truncate') }, props));
}
export function BreadcrumbSeparator({ className }) {
    return (_jsx(ChevronRightIcon, { className: clsx(className, 'size-5 sm:size-4 flex-shrink-0 text-zinc-500 dark:text-zinc-400'), "aria-hidden": "true" }));
}
